import { TextField } from '@material-ui/core';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { AssessmentSessionState } from '../../../../Dashboard/Dashboard.types';
import { useStyles } from '../SessionsProcessLimits.styles';
import { ProcessLimitRow, SessionsParamatersProcessLimitsKey } from '../SessionsProcessLimits.types';
import { Prompt } from '../../../../../components/Prompt/Prompt.component';
import { blockIconForInput, blockIconForInputWithOptions } from '../../../../../components/EditSession/BlockItemForInput';

interface SessionProcessLimitFieldProps {
  value: ProcessLimitRow;
  initialValue: number;
  type: SessionsParamatersProcessLimitsKey;
  handleValueChange: (type: SessionsParamatersProcessLimitsKey, value: number | null, id: string | number) => void;
  isValid: boolean;
  isRequired: boolean;
  isDisabled?: boolean;
  validation?: (row: ProcessLimitRow) => boolean;
  ariaLabel?: string;
}

export const SessionProcessLimitField: React.FC<SessionProcessLimitFieldProps> = ({
  value,
  initialValue,
  type,
  handleValueChange,
  isValid,
  validation,
  isRequired,
  isDisabled,
  ariaLabel,
}) => {
  const styles = useStyles();
  const [openConfirmation, setOpenConfirmaton] = useState<boolean>(false);
  const [fieldValue, setFieldValue] = useState<number | null>(null);

  const onValueChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const val = Math.abs(parseInt(e.target.value));
      setFieldValue(val);
      if (value.assessmentSessionStateId !== AssessmentSessionState.New && type !== 'controlZWOLimitValue' && val === 0)
        return;
      if (
        value.assessmentSessionStateId !== AssessmentSessionState.New &&
        type === 'controlZWOLimitValue' &&
        val === 0
      ) {
        setOpenConfirmaton(true);
      }
      const rowValue: ProcessLimitRow = { ...value, [type]: val };
      handleValueChange(type, val, value.examTaskGroupId);
      if (validation) {
        validation(rowValue);
      }
    },
    [type, value, handleValueChange],
  );
  return (
    <>
      <TextField
        name={type}
        className={isRequired ? styles.textField : ''}
        onChange={onValueChange}
        variant="outlined"
        type="number"
        inputProps={{
          'aria-label': ariaLabel,
          style: {
            padding: '7px',
            width: '46px',
            fontSize: '1rem',
          },
          min: 0,
        }}
        style={{
          maxWidth:"60px"
        }}
        value={initialValue}
        error={isRequired ? false : isValid}
        disabled={isDisabled}
        InputProps={{
          startAdornment: blockIconForInputWithOptions({
            isDisabled,
            iconStyle:{
              fontSize:'small',
            },
            inputAdornmentStyle:{
              marginLeft:'-12px',
            }
          }),
        }}
      />
      <Prompt
        type="confirmation"
        open={openConfirmation}
        size="sm"
        onCancel={() => {
          const rowValue: ProcessLimitRow = { ...value, [type]: 1 };
          handleValueChange(type, 1, value.examTaskGroupId);
          if (validation) {
            validation(rowValue);
          }
          setOpenConfirmaton(false);
        }}
        onConfirm={() => {
          handleValueChange(type, fieldValue, value.examTaskGroupId);
          setOpenConfirmaton(false);
        }}
        cancelButtonText="ANULUJ"
        mainActionButtonText="TAK"
        mainText={<>Czy na pewno chcesz wyłączyć proces kontrolny?</>}
        subTexts={[
          {
            text: <>Wyłączenie procesu kontrolnego uniemożliwi jego ponowne włączenie.</>,
          },
        ]}
      />
    </>
  );
};
